import dayjs, { Dayjs } from 'dayjs';

export const isFutureDate = (date: string | Date): boolean => dayjs(date).isAfter(dayjs());

export const isPastDate = (date: string | Date): boolean => dayjs(date).isBefore(dayjs());

export const isAfterCollectionDeadline = (deadline?: Dayjs): boolean => dayjs().isAfter(
  deadline,
);

export const isToday = (date: string | Date): boolean => dayjs(date).isToday();

export const formatDate = (date: string | Date, format = 'ddd, D MMM'): string => dayjs(date).format(format);

// it would convert form UTC time to user local time zone
export const formatTime = (date: string | Date): string => dayjs(date).format('HH:mmA');
